module.exports = __webpack_public_path__ + "rs.svg?fb61a99894fe97bdc88fe7f26a6d8f9d";